WYATT.registerComponent(
  "product-options",
  class ProductOptions extends HTMLElement {
    constructor() {
      super();

      this.product = window.WYATT.shopify.product[this.dataset.productOptions];
      this.options = this.querySelectorAll("[data-product-option]");
      this.selectedOptions = this.getSelectedOptions();
      this.selectedVariant = this.getSelectedVariant();
      this.saleToggle = this.querySelector(
        `[data-sale-toggle="${this.dataset.productOptions}"]`
      );

      const debouncedHandler = WYATT.debounce((event) => {
        this.handleOptionChange(event);
      }, 300);

      this.options.forEach((option) => {
        this.mapVariantsToOption(option);
        option.addEventListener("change", debouncedHandler.bind(this));
      });

      this.saleToggle?.addEventListener(
        "change",
        this.filterOptions.bind(this)
      );

      this.filterOptions();
    }

    handleOptionChange(event) {
      this.selectedVariant = null;
      this.selectedOptions = this.getSelectedOptions();

      this.updateSelectedOptionText(event.target);
      this.filterOptions();

      this.selectedVariant = this.getSelectedVariant();

      if (this.selectedVariant) {
        this.showLoading();
        this.updateProductDOM();
        this.updateFormInput();
      } else {
        this.autoSelectOption(event.target);
      }
    }

    updateFormInput() {
      this.querySelector('[name="id"]').value = this.selectedVariant;
    }

    getSelectedOptions() {
      const checkedInputs = Array.from(
        this.querySelectorAll("[data-product-option]:checked")
      );

      return checkedInputs.map(({ value }) => value);
    }

    getSelectedVariant() {
      const selectedOptions = JSON.stringify(this.selectedOptions);
      const variant = this.product.variants.find(
        ({ options }) => JSON.stringify(options) === selectedOptions
      );

      return variant?.id;
    }

    async updateProductDOM() {
      const url = this.getURL(true);
      const response = await WYATT.asyncRequest(url);

      if (response) {
        this.handleSuccessfulUpdate(response);
      } else {
        this.handleUnsuccessfulUpdate();
      }

      this.hideLoading();
    }

    replaceProductDetailSectionComponents(html) {
      const elementsToReplace = [
        "[data-product-media]",
        "[data-product-prices]",
        "[data-availability]",
        "[data-add-to-cart]",
        "[data-back-in-stock]",
        "[data-sku-display]",
        "[data-store-pickup-only]",
      ];
      const product = this.closest(".product-details");
      const newDOM = new DOMParser().parseFromString(html, "text/html");
      const newProduct = newDOM.querySelector(".product-details");

      elementsToReplace.forEach((selector) => {
        const elements = product.querySelectorAll(selector);
        const newElement = newProduct.querySelector(selector);

        elements.forEach((element) => {
          if (newElement) {
            this.replaceHTML(element, newElement.outerHTML);
          }
        });
      });
    }

    replaceHTML(element, html) {
      if (element) {
        element.outerHTML = html;
      }
    }

    handleSuccessfulUpdate(response) {
      const sections = JSON.parse(response);

      Object.keys(sections).forEach((section) => {
        if (section === "product-details") {
          this.replaceProductDetailSectionComponents(sections[section]);
        } else {
          const element = document.querySelector(`[id*="${section}"]`);
          this.replaceHTML(element, sections[section]);
        }
      });

      window.history.replaceState(null, "", this.getURL());
    }

    handleUnsuccessfulUpdate() {
      window.location.href = this.getURL();
    }

    showLoading() {
      this.classList.add("product-options--updating");
    }

    hideLoading() {
      this.classList.remove("product-options--updating");
    }

    getURL(includeViewParam = false) {
      const search = new URLSearchParams(window.location.search);

      search.set("variant", this.selectedVariant);

      if (includeViewParam) {
        search.set("sections", this.getSections());
      }

      return `${window.location.origin}${
        window.location.pathname
      }?${search.toString()}`;
    }

    getSections() {
      const sectionIDs = ["product-details"];
      const elementsToUpdate = document.querySelectorAll(
        "[data-update-on-product-options-change]"
      );
      const shopifySectionPrefix = "shopify-section-";

      elementsToUpdate.forEach((element) => {
        const section = element.closest(
          `section[id^="${shopifySectionPrefix}"]`
        );

        if (section) {
          sectionIDs.push(section.id.split(shopifySectionPrefix)[1]);
        }
      });

      return sectionIDs.filter((id) => id); // Clean up just in case any falsy values get in there
    }

    autoSelectOption(input) {
      const optionIndex = this.product.options.indexOf(input.name);
      const variant = this.product.variants.find(
        ({ options }) => options[optionIndex] === input.value
      );

      variant.options.forEach((value) => {
        const option = this.querySelector(`[value="${value}"]`);

        if (!option.checked) {
          const event = new Event("change");

          option.checked = true;
          option.dispatchEvent(event);
        }
      });
    }

    updateSelectedOptionText(input) {
      const selectedOptionTextElement = input
        .closest("[data-product-options]")
        .querySelector(`[data-selected-${input.dataset.productOption}]`);

      selectedOptionTextElement.textContent = input.value;
    }

    mapVariantsToOption(option) {
      const matchingVariants = this.product.variants.filter(({ options }) =>
        options.includes(option.value)
      );

      option.dataset.variants = JSON.stringify(matchingVariants);
    }

    filterOptions() {
      this.options.forEach((option) => {
        const matchingVariants = JSON.parse(option.dataset.variants);
        const optionIndex = this.product.options.indexOf(option.name);
        const optionValues = [...this.selectedOptions];

        optionValues[optionIndex] = option.value;

        const matchingVariant = matchingVariants.find(
          ({ options }) =>
            JSON.stringify(options) === JSON.stringify(optionValues)
        );

        this.updateOptionForAvailability(option, matchingVariant);
      });
    }

    updateOptionForAvailability(option, variant) {
      const label = option.nextElementSibling;
      let addOrRemove = variant?.available ? "remove" : "add";

      label.classList[addOrRemove]("product-option__label--unavailable");

      if (this.saleToggle?.checked) {
        addOrRemove =
          variant.price < variant.compare_at_price ? "remove" : "add";
      } else {
        addOrRemove = "remove";
      }

      label.classList[addOrRemove]("product-option__label--hidden");
    }
  }
);
